
import { useStore } from "vuex";
import { defineComponent } from "vue";
import GenericButton from "../shared/GenericButton.vue";

export default defineComponent({
  name: "Perks",
  components: {
    GenericButton,
  },
  setup() {
    const store = useStore();
    const getButtonClass = (category: string, perk: string) => {
      const perkData = store.state.build[category][perk];
      const currentPerk = store.state.build.info.currentPerk;
      if (perkData.tagged) {
        return "perk-button perk-tagged";
      } else if (perkData.available) {
        if (
          (category === "Perks" && currentPerk.available) ||
          ["SupportPerks", "MysteryBoosts"].includes(category)
        ) {
          return "perk-button perk-available item-hover";
        } else {
          return "perk-button perk-not-available";
        }
      } else {
        return "perk-button perk-not-available";
      }
    };

    const tagPerk = (category: string, perk: string) => {
      store.dispatch("handleIncomingCommand", {
        command: "tagPerk",
        data: { category, perk },
      });
    };

    const showInfo = (category: string, stat: string) => {
      store.dispatch("handleIncomingCommand", {
        command: "updateInfoPanel",
        data: { category, stat },
      });
    };

    const getPerkWarningClass = () => {
      const currentLevel = store.state.build.info.currentLevel;
      const nextPerkAt = store.state.build.info.currentPerk.nextAtLevel;
      const skilled = store.state.build.Traits.Skilled.tagged;
      const diff = nextPerkAt - currentLevel;

      if (diff === 1) {
        return "text-red";
      } else if (diff === 2) {
        return "text-yellow";
      } else if (diff === 3) {
        return skilled ? "text-yellow" : "text-green";
      } else if (diff === 4) {
        return "text-green";
      } else {
        return "text-red";
      }
    };

    const getPerkButtonName = (category: string, perk: string) => {
      return `${store.state.build[category][perk].name} ${
        store.state.build[category][perk].taggedAt
          ? `(${store.state.build[category][perk].taggedAt})`
          : ""
      }`;
    };

    return {
      state: store.state,
      getButtonClass,
      tagPerk,
      showInfo,
      getPerkWarningClass,
      getPerkButtonName,
    };
  },
});
